import { PlayerRef } from '@remotion/player';
import { useCallback } from 'react';

export function useCaptureCurrentFrame(
  playerRef: React.RefObject<PlayerRef | null>,
) {
  const captureFrame = useCallback(async (): Promise<string | null> => {
    const container = playerRef.current?.getContainerNode();
    if (!container) return null;

    // video 요소에서 캡처 시도
    const video = container.querySelector('video');
    if (video) {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth || 1920;
      canvas.height = video.videoHeight || 1080;
      const ctx = canvas.getContext('2d');
      if (!ctx) return null;
      ctx.drawImage(video, 0, 0);
      return canvas.toDataURL('image/png');
    }

    // canvas 요소에서 캡처 시도
    const canvasEl = container.querySelector('canvas');
    if (canvasEl) {
      return canvasEl.toDataURL('image/png');
    }

    return null;
  }, [playerRef]);

  return { captureFrame };
}
